import { ModuleConfiguration } from '../../business-rule.module.config';
import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { ModuleListModel } from '../../models/ModuleListModel';
import { ModuleModel } from '../../models/ModuleModel';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';
import { ruleReducer } from './rule.reducer';
import { moduleReducer } from './module.reducer';
import { parameterReducer } from './parameter.reducer';
import { RuleState } from '../state/RuleState';
import { RuleModel } from '../../models/RuleModel';
import { RuleListModel } from '../../models/RuleListModel';
import { UpdateParametersModel } from '../../models/UpdateParametersModel';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface BusinessRuleState {
  moduleState: TileState<ModuleListModel, ModuleModel>,
  ruleState: TileState<RuleListModel, RuleModel>;
  parametersState: UpdateParametersModel;
};

export const reducers = {
  ruleState: ruleReducer,
  moduleState: moduleReducer,
  parametersState: parameterReducer
};

export const getBusinessRuleState = createFeatureSelector(ModuleConfiguration.moduleName);

export const getRuleState = createSelector(getBusinessRuleState, (s: BusinessRuleState) => s.moduleState);
export const getRuleList = createSelector(getRuleState, (s: TileState<ModuleListModel, ModuleModel>) => s.list);
export const getRuleListLoading = createSelector(getRuleState, (s: TileState<ModuleListModel, ModuleModel>) => s.loading);

export const getParameters = createSelector(getBusinessRuleState, (s: BusinessRuleState) => s.parametersState);



// WEBPACK FOOTER //
// ./src/app/businessRule/store/reducers/index.ts